import { render, staticRenderFns } from "./RemarkSetup.vue?vue&type=template&id=50d438ca&"
import script from "./RemarkSetup.vue?vue&type=script&lang=js&"
export * from "./RemarkSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports